import styled from "styled-components";

const MainSummaryContainer = styled.div`
  border-top: 1px solid rgb(33, 175, 196);
  z-index: 2;
  .summary {
    width: 50%;
    display: flex;
    margin: 0 auto;
    .summarycard {
      height: 18vh;
      overflow: hidden;
      width: 33%;
      border: 1px solid #efefef;
      padding: 0 1em;
      .header {
        display: flex;
        padding-top: 1em;
        h6 {
          margin: 0;
          color: rgb(33, 175, 196);
          font-size: 1rem;
          font-weight: 100;
        }
        button {
          border: 1px solid #efefef;
          font-size: 0.5rem;
          padding: 0.25em;
          width: 15%;
          background-color: transparent;
          cursor: pointer;
          height: 50%;
          margin: auto 0;
          margin-left: auto;
        }
      }
      ul {
        font-size: 0.5rem;
        padding-left: 2.5em;
      }
      .img {
        width: 100%;
        height: 50%;
        border-bottom: 1px solid #efefef;
      }
      img {
        width: 100%;
        height: 100%;
      }
      &:last-child {
        padding: 0;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

export default MainSummaryContainer;
